module.exports = __webpack_public_path__ + "img/ven.b2cd5a9a.svg";